/**
 * Ryan O'Dowd
 * 2025-05-15
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Image as RNImage,
} from 'react-native';
import React from 'react';

const Image = (props: ImageProps) => {
  return (
    <RNImage
      style={[props.style, {objectFit: props.resizeMode}]}
      source={props.source}
      onError={props.onError}
      alt={props.username}
    />
  );
};

class ImageProps { // @TODO: need this? combine with native and use types of rnimage
  style: {};
  source: {};
  resizeMode: any;

  onError?: () => void;
  username?: string;
};

export default Image;
